import { useQuery } from 'react-query';
import { getUserProfileInfo } from 'src/apis/profile';
import { GetUserProfileAPIResponse } from 'types';

export const useGetUserProfile = (handler: string) => {
	return useQuery({
		queryKey: ['getUserProfile', handler],
		queryFn: async () => (await getUserProfileInfo(handler)) as GetUserProfileAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		enabled: !!handler,
	});
};
